export default __webpack_public_path__ + "static/media/newFamilyIllustration.427283f0.png";